import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApartadoComponent } from './apartado/lista.component';
import { ArticuloComponent } from './articulo/lista.component';
import { CajaComponent } from './caja/lista.component';
import { ClienteComponent } from './cliente/lista.component';
import { CompraComponent } from './compra/lista.component';
import { CategoriaComponent } from './categoria/lista.component';
import { ProveedorComponent } from './proveedor/lista.component';
import { TraspasoComponent } from './traspaso/lista.component';
import { VendedorComponent } from './vendedor/lista.component';
import { VentaComponent } from './venta/lista.component';

import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  { path: 'reportes/grafico', redirectTo: '/reporte/grafico/grafico', pathMatch: 'full' },
  {
    path: 'reportes/grafico',
    children: [
      { path: 'apartado', component: ApartadoComponent },
      { path: 'articulo', component: ArticuloComponent },
      { path: 'caja', component: CajaComponent },
      { path: 'cliente', component: ClienteComponent },
      { path: 'compra', component: CompraComponent },
      { path: 'categoria', component: CategoriaComponent },
      { path: 'proveedor', component: ProveedorComponent },
      { path: 'traspaso', component: TraspasoComponent },
      { path: 'vendedor', component: VendedorComponent },
      { path: 'venta', component: VentaComponent }
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ReporteGraficoRoutingModule { }

